  /*=========================================================================================
          File Name: actions.js
          Description: Vuex Store - actions
          ----------------------------------------------------------------------------------------
          Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
          Author: Pixinvent
          Author URL: http://www.themeforest.net/user/pixinvent
        ==========================================================================================*/

  import axios from 'axios';
  import { config } from '../shared/app.config';
  import qrApi from '../api/qr-api';
  import landingApi from '../api/landing-api';
  import router from '../router';
  import menusApi from '@/api/menus-api';
  import restaurantsApi from '../api/restaurants-api';

  const actions = {

      // /////////////////////////////////////////////
      // COMPONENTS
      // /////////////////////////////////////////////

      // Vertical NavMenu
      updateVerticalNavMenuWidth({ commit }, width) {
          commit('UPDATE_VERTICAL_NAV_MENU_WIDTH', width)
      },

      // VxAutoSuggest
      updateStarredPage({ commit }, payload) {
          commit('UPDATE_STARRED_PAGE', payload)
      },

      // The Navbar
      arrangeStarredPagesLimited({ commit }, list) {
          commit('ARRANGE_STARRED_PAGES_LIMITED', list)
      },
      arrangeStarredPagesMore({ commit }, list) {
          commit('ARRANGE_STARRED_PAGES_MORE', list)
      },

      // /////////////////////////////////////////////
      // UI
      // /////////////////////////////////////////////

      toggleContentOverlay({ commit }) {
          commit('TOGGLE_CONTENT_OVERLAY')
      },
      updateTheme({ commit }, val) {
          commit('UPDATE_THEME', val)
      },

      // /////////////////////////////////////////////
      // User/Account
      // /////////////////////////////////////////////

      updateUserInfo({ commit }, payload) {
          commit('UPDATE_USER_INFO', payload)
      },
      generateQR({ commit }, { type, id }) {
          commit('loading', true);
          qrApi.generateQR(type, id)
              .then(
                  response => {
                      const file = new Blob(
                          [response.data], { type: 'application/pdf' });
                      //Build a URL from the file
                      const fileURL = URL.createObjectURL(file);
                      //Open the URL on new Window
                      window.open(fileURL);
                      commit('loading', false);
                  },
                  error => {
                      commit('loading', false);
                  }
              );
      },
      redirectQR({ commit }, id) {
          commit('loading', true);
          qrApi.redirectQR(id)
              .then(
                  response => {
                      window.location.href = response.data.url;
                  },
                  error => {
                      commit('notfound', true);
                  }
              );
      },

      downloadReport({ commit }, { type, id }) {
          commit('loading', true);
          return restaurantsApi.downloadReport(id)
      },




      sendFormPublic({ commit, dispatch }, { form }) {
          commit('loading', true);

          landingApi.sendForm(form)
              .then(
                  response => {
                      commit('notifications', { title: 'formularioEnviado' });
                      commit('loading', false);
                      commit('showNotifications', true);
                  },
                  error => {
                      commit('notifications', { title: 'formularioError', color: 'danger' });
                      commit('loading', false);
                      commit('showNotifications', true);
                  }
              );
      },

  }

  export default actions